import { useCallback } from "react";

import { useContentItems } from "@is/hooks";
import { SearchTerm } from "@is/types";

export const useSearch = () => {
  const { handleSearchProducts, isPending } = useContentItems();

  const handleSearch = useCallback(
    ({
      searchTerms,
      pageNumber,
      sectionId,
      enableFocusedItem,
      showDrawers,
    }: {
      searchTerms: SearchTerm[];
      pageNumber?: number;
      sectionId?: string;
      enableFocusedItem?: boolean;
      showDrawers?: boolean;
    }) => {
      handleSearchProducts({
        newSearchTerms: searchTerms,
        pageNumber: pageNumber || 1,
        sectionId,
        enableFocusedItem,
        showDrawers,
      });
    },
    [handleSearchProducts]
  );

  return { handleSearch, isPending };
};
